const surveyStatus = {
  NOT_SUBMITTED: 'NOT_SUBMITTED',
  CHANGES_REQUIRED: 'CHANGES_REQUIRED',
  RESCORING_REQUIRED: 'RESCORING_REQUIRED',
  IN_LEGO_REVIEW: 'IN_LEGO_REVIEW',
  COMPLETED: 'COMPLETED',
};

export { surveyStatus };
